export default __webpack_public_path__ + "static/media/Slide01-Digital-Classroom - Copy.9239d2a0.png";